/* eslint-disable no-invalid-this */

import {STATUS} from '../constants';

const initVRVideos = () => {
  const VRPlayer = document.querySelector('[data-vr-player]');

  if (!VRPlayer) {
    return;
  }

  const videoWrappers = VRPlayer.querySelectorAll('.video[data-vr-video-id]');
  const videoControls = VRPlayer.querySelectorAll(
      '.player-btn[data-vr-video-id]'
  );
  const startBtn = VRPlayer.querySelector('[data-vr-start]');

  function startWatchingVideo() {
    startPlayer();
  }

  function startPlayer() {
    VRPlayer.dataset.playerStatus = STATUS.isPlaying;
  }

  function pausePlayer() {
    VRPlayer.dataset.playerStatus = STATUS.isPaused;
  }

  function playVideo() {
    const videoWrapper = document.querySelector(
        `.video[data-vr-video-id="${VRPlayer.dataset.currentVideo}"]`
    );
    const video = videoWrapper.querySelector('video');
    videoWrapper.classList.add('is-active');
    video.play();
  }

  function pauseVideo() {
    const videoWrapper = document.querySelector(
        `.video[data-vr-video-id="${VRPlayer.dataset.currentVideo}"]`
    );
    const video = videoWrapper.querySelector('video');
    video.pause();
  }

  function pauseAllVideo() {
    const videosForPause = [...videoWrappers].filter((wrapper) => {
      return VRPlayer.dataset.currentVideo !== wrapper.dataset.vrVideoId;
    });
    videosForPause.forEach((wrapper) => {
      const video = wrapper.querySelector('video');
      const control = VRPlayer.querySelector(
          `.player-btn[data-vr-video-id="${wrapper.dataset.vrVideoId}"]`
      );
      wrapper.classList.remove('is-active');
      control.dataset.playStatus = STATUS.isPaused;
      video.pause();
    });
  }

  function setVideo(id) {
    VRPlayer.dataset.currentVideo = id;
  }

  function toggleControlStatus(control, status) {
    control.dataset.playStatus = status;
  }

  function videoBtnHandler() {
    if (VRPlayer.dataset.playerStatus === STATUS.isPaused) {
      VRPlayer.dataset.playerStatus = STATUS.isPlaying;
    } else if (VRPlayer.dataset.playerStatus === STATUS.isPlaying) {
      VRPlayer.dataset.playerStatus = STATUS.isPaused;
    }
  }

  function endHandler() {
    const videoWrapper = this.closest('.video');
    VRPlayer.dataset.playerStatus = STATUS.isPaused;
    videoWrapper.dataset.playStatus = STATUS.isPaused;
    this.pause();
  }

  function controlHandler() {
    const control = this;
    const controlId = control.dataset.vrVideoId;
    const controlStatus = control.dataset.playStatus;

    VRPlayer.dataset.playerStatus = STATUS.isPaused;
    setVideo(controlId);

    if (controlStatus === STATUS.isPlaying) {
      VRPlayer.dataset.playerStatus = STATUS.isPaused;
      pausePlayer();
    } else if (controlStatus === STATUS.isPaused) {
      VRPlayer.dataset.playerStatus = STATUS.isPlaying;
    }
  }

  if (videoWrappers.length > 0 && startBtn) {
    videoWrappers[0].classList.add('is-active');

    videoWrappers.forEach((videoWrapper) => {
      const video = videoWrapper.querySelector('video');
      video.addEventListener('ended', endHandler);
      videoWrapper.addEventListener('click', videoBtnHandler);
    });

    videoControls.forEach((control) => {
      control.addEventListener('click', controlHandler);
    });

    const currentVideoHandler = () => {
      const currentControl = VRPlayer.querySelector(
          `.player-btn[data-vr-video-id="${VRPlayer.dataset.currentVideo}"]`
      );
      pauseAllVideo();
      if (VRPlayer.dataset.playerStatus === STATUS.isPlaying) {
        playVideo();
        toggleControlStatus(currentControl, STATUS.isPlaying);
      } else if (VRPlayer.dataset.playerStatus === STATUS.isPaused) {
        pauseVideo();
        toggleControlStatus(currentControl, STATUS.isPaused);
      }
    };

    const playerObserver = new MutationObserver(currentVideoHandler);
    const config = {attributes: true};

    playerObserver.observe(VRPlayer, config);

    startBtn.addEventListener('click', startWatchingVideo);
  }
};

export {initVRVideos};
